import { TOP_SELLING_SERVER_DATA } from "../../constant/CompanyData";

const HomeTopServers = () => {
  return (
    <section className="bg-[var(--surface-dark)] px-6 py-20">
      <div className="mx-auto max-w-6xl">
        <div className="text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[var(--website-secondary-color)]">
            Enterprise hardware
          </p>
        </div>
        <h2 className="mt-3 text-center text-3xl font-bold tracking-tight text-white md:text-4xl">
          Our Top Selling Servers
        </h2>

        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {TOP_SELLING_SERVER_DATA.map((server, index) => (
            <div
              key={index}
              className={`rounded-2xl border p-7 transition duration-300 hover:-translate-y-1 ${
                index === 1
                  ? "border-[rgba(var(--website-secondary-rgb),0.6)] bg-white/10 shadow-lg shadow-[rgba(var(--website-secondary-rgb),0.1)]"
                  : "border-white/10 bg-white/5 hover:border-[rgba(var(--website-secondary-rgb),0.4)] hover:bg-white/10"
              }`}
            >
              <p
                className={`text-xs font-semibold uppercase tracking-[0.16em] ${
                  index === 1
                    ? "text-[var(--website-secondary-color)]"
                    : "text-slate-400"
                }`}
              >
                Refurbished enterprise server
              </p>
              <h3 className="mt-3 text-xl font-bold text-white">
                {server.title}
              </h3>
              <div className="mt-6 font-bold text-white">
                <span className="mr-1 text-2xl">₹</span>
                <span className="text-4xl">{server.price}</span>
              </div>
              <p className="mt-1 text-sm text-slate-400">{server.currency}</p>
              <ul className="mt-6 space-y-2 text-sm leading-relaxed text-slate-300">
                {server.description.map((line, i) => (
                  <li key={i} className="flex gap-2">
                    <span className="text-[var(--website-secondary-color)]">
                      ✓
                    </span>
                    {line}
                  </li>
                ))}
              </ul>

              <a
                href="https://www.interseller.in/"
                target="_blank"
                rel="noopener noreferrer"
                className={`mt-7 inline-flex rounded-full px-5 py-3 text-sm font-semibold transition ${
                  index === 1
                    ? "bg-[var(--website-secondary-color)] text-[var(--on-secondary)] hover:brightness-110"
                    : "border border-white/20 bg-white/10 text-white hover:border-[var(--website-secondary-color)] hover:bg-white/20"
                }`}
              >
                View configuration
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeTopServers;
